import React from 'react'
import './style.css'
import {Link} from 'react-router-dom'

export default (props) =>{
    return(
        <div className='__rodape'>
            <div className='inner_rodape_container'>
                <div className='mapa_site'>
                <ul>
                    <li>Site
                        <ul>
                            <li><Link to='/'>Página principal (apresentação)</Link></li>
                            <li><Link to='/empreendimento'>Empreendimento (página institucional)</Link></li>
                            <li><Link to='/saiba_como'>Saiba como (página informativa de negócios)</Link></li>
                            <li><Link to='/contato'>Entre em contato (página de contato simples)</Link></li>
                            <li><Link to='/imagens'>Confira as imagens (página de galeria de imagens e vídeio)</Link></li>
                            <li><Link to='/mapa'>Áreas disponíveis (página de mapa inteligente de estado de vendas do loteamento)</Link></li>
                        </ul>
                    </li>                       
                </ul>
                
                </div>
                <div className='empowerd'>
                    <span>Desenvolvido por IGDEV Ícaro Glauco <a href="http://fb.com/icaro.glauco" target="_blank">fb.com/icaro.glauco</a></span>
                </div>
                <div className='wma'>
                    Realização:
                    <span className='WMA_realiza'></span>                

                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/rodape/component.js